/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SettlementDetailDto } from '../../models/settlement-detail-dto';

export interface SettlementControllerProcessPayment$Params {

/**
 * 정산 상세 ID
 */
  detailId: string;
}

export function settlementControllerProcessPayment(http: HttpClient, rootUrl: string, params: SettlementControllerProcessPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<SettlementDetailDto>> {
  const rb = new RequestBuilder(rootUrl, settlementControllerProcessPayment.PATH, 'patch');
  if (params) {
    rb.path('detailId', params.detailId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SettlementDetailDto>;
    })
  );
}

settlementControllerProcessPayment.PATH = '/api/settlement/detail/{detailId}/pay';
